import React from 'react';
import PropTypes from 'prop-types';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { useTranslation } from 'react-i18next';
import { mapCalendarToCalendars, mapCalendarToLocales } from 'utils';
import 'react-multi-date-picker/styles/colors/teal.css';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import AnalogTimePicker from 'react-multi-date-picker/plugins/analog_time_picker';
import UiTextField from 'ui-components/ui-text-field/UiTextField';
import { UiButton } from 'ui-components';

/**
 * کامپوننت مربوط به قسمت انتخاب ساعت
 * @returns
 */
export function TimePicker(props) {
  const { t } = useTranslation();
  const {
    fromTime,
    toTime,
    values = [],
    selectedCalendar,
    onTimeChange,
    handleToNow,
  } = props;

  const renderTimePicker = (selectedTime, testId) => {
    return (
      <DatePicker
        // eslint-disable-next-line react/jsx-no-undef
        render={(value, openCalendar) => {
          return (
            <UiTextField
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <UiIcon
                    icon='ri-time-line mr-8'
                    color='#AAAAAA'
                    hover='#AAAAAA'
                  />
                ),
              }}
              style={{ width: 120 }}
              onClick={openCalendar}
              value={value}
              inputProps={{
                'data-testid': `${props?.['data-testid']}${testId}`,
              }}
            />
          );
        }}
        disableDayPicker
        format='HH:mm'
        // eslint-disable-next-line react/jsx-key
        plugins={[<AnalogTimePicker hideSeconds />]}
        calendar={mapCalendarToCalendars[selectedCalendar]}
        locale={mapCalendarToLocales[selectedCalendar]}
        calendarPosition='bottom-right'
        value={selectedTime}
        onChange={onTimeChange}
        portal
      />
    );
  };

  return (
    <div className='time-picker flex plr-20 pt-8 rtl'>
      <div className='from-time-picker text-right'>
        <div className='pb-4'>
          {t('common:from')} {new DateObject(values[0]).format('DD MMMM')}{' '}
          {t('common:time')}
        </div>
        {renderTimePicker(fromTime, '-time-from')}
      </div>
      {values[1] ? (
        <div className='to-time-picker text-right'>
          <div className='pb-4'>
            {t('common:to')} {new DateObject(values[1]).format('DD MMMM')}{' '}
            {t('common:time')}
          </div>
          {renderTimePicker(toTime, '-time-to')}
        </div>
      ) : (
        <UiButton
          style={{ alignSelf: 'flex-end' }}
          variant='ghost'
          color='primary'
          onClick={handleToNow}
          textColor='#199da3'
          data-testid={`${props?.['data-testid']}-action-now`}
        >
          {t('common:now')}
        </UiButton>
      )}
    </div>
  );
}

TimePicker.propTypes = {
  fromTime: PropTypes.object,
  toTime: PropTypes.object,
  values: PropTypes.array,
  onTimeChange: PropTypes.func,
  'data-testid': PropTypes.string,
  selectedCalendar: PropTypes.string,
  handleToNow: PropTypes.func,
};
